import {
  appointmentHistoryTableColumnsAdmin,
  appointmentHistoryTableColumnsAssociate,
  appointmentHistoryTableColumnsClient,
} from '../../../constants/tableColumns';
import { useAppointmentHistoryContext } from '../../../contexts/AppointmentHistoryProvider';
import { useAuthContext } from '../../../contexts/AuthProvider';
import useCheckUserFeaturePermissions from '../../../hooks/useCheckUserFeaturePermissions';
import { User } from '../../../types/users';
import AcademiaNotFound from '../../CommonComps/AcademiaNotFound';
import AcademiaLoading from '../../CommonComps/Loadings/AcademiaLoading';
import AcademiaTable from '../../CommonComps/Tables/AcademiaTable';
import PageHeader from '../../CommonComps/Titles/PageHeader';

const ShowAllAppointmentHistory = () => {
  // integration of context hooks here
  const { currentUser, currentUserType } = useAuthContext();

  // integration of context hooks here
  const { isLoading, isSuccess, isError, appointmentHistoryList } =
    useAppointmentHistoryContext();

  // integration of custom hooks here
  const { featureBasedPermissions } = useCheckUserFeaturePermissions(
    'appointmentRequest',
    true
  );

  // rendering show all appointment history section component here
  return (
    <>
      {isLoading ? (
        <AcademiaLoading />
      ) : isSuccess ? (
        featureBasedPermissions?.includes('READ') ? (
          <section>
            <PageHeader headerText='Appointment History' />

            <AcademiaTable
              data={appointmentHistoryList}
              columns={
                (currentUser as User)?.role_name === 'Admin'
                  ? appointmentHistoryTableColumnsAdmin
                  : currentUserType === 'user' &&
                    (currentUser as User)?.role_name !== 'Admin'
                  ? appointmentHistoryTableColumnsAssociate
                  : appointmentHistoryTableColumnsClient
              }
              notFoundMessage='No Appointment found!'
            />
          </section>
        ) : (
          <AcademiaLoading />
        )
      ) : isError ? (
        <AcademiaNotFound message='No appointment history found!' />
      ) : null}
    </>
  );
};

export default ShowAllAppointmentHistory;
